import {
  getGochiEventSettingData,
  getGochiEventSettingDetailData,
  addGochiEventSettingData,
  editGochiEventSettingData,
  deleteEventSettingData,
  getGochiEventSettingDataByMenuId,
  connectGochiEventSettingData,
  updateStatusGochiEventSettingData
} from '../libs/apis/GochiEventSetting';

export const GET_GOCHI_EVENT_SETTING_REQUEST =
  'GET_GOCHI_EVENT_SETTING_REQUEST';
export const GET_GOCHI_EVENT_SETTING_SUCCESS =
  'GET_GOCHI_EVENT_SETTING_SUCCESS';
export const GET_GOCHI_EVENT_SETTING_FAILURE =
  'GET_GOCHI_EVENT_SETTING_FAILURE';

export const GET_GOCHI_EVENT_SETTING_DETAIL_REQUEST =
  'GET_GOCHI_EVENT_SETTING_DETAIL_REQUEST';
export const GET_GOCHI_EVENT_SETTING_DETAIL_SUCCESS =
  'GET_GOCHI_EVENT_SETTING_DETAIL_SUCCESS';
export const GET_GOCHI_EVENT_SETTING_DETAIL_FAILURE =
  'GET_GOCHI_EVENT_SETTING_DETAIL_FAILURE';

export const ADD_GOCHI_EVENT_SETTING_REQUEST =
  'ADD_GOCHI_EVENT_SETTING_REQUEST';
export const ADD_GOCHI_EVENT_SETTING_SUCCESS =
  'ADD_GOCHI_EVENT_SETTING_SUCCESS';
export const ADD_GOCHI_EVENT_SETTING_FAILURE =
  'ADD_GOCHI_EVENT_SETTING_FAILURE';

export const EDIT_GOCHI_EVENT_SETTING_REQUEST =
  'EDIT_GOCHI_EVENT_SETTING_REQUEST';
export const EDIT_GOCHI_EVENT_SETTING_SUCCESS =
  'EDIT_GOCHI_EVENT_SETTING_SUCCESS';
export const EDIT_GOCHI_EVENT_SETTING_FAILURE =
  'EDIT_GOCHI_EVENT_SETTING_FAILURE';

export const DELETE_EVENT_SETTING_REQUEST = 'DELETE_EVENT_SETTING_REQUEST';
export const DELETE_EVENT_SETTING_SUCCESS = 'DELETE_EVENT_SETTING_SUCCESS';
export const DELETE_EVENT_SETTING_FAILURE = 'DELETE_EVENT_SETTING_FAILURE';

export const GET_GOCHI_EVENT_SETTING_BY_MENU_REQUEST =
  'GET_GOCHI_EVENT_SETTING_BY_MENU_REQUEST';
export const GET_GOCHI_EVENT_SETTING_BY_MENU_SUCCESS =
  'GET_GOCHI_EVENT_SETTING_BY_MENU_SUCCESS';
export const GET_GOCHI_EVENT_SETTING_BY_MENU_FAILURE =
  'GET_GOCHI_EVENT_SETTING_BY_MENU_FAILURE';

export const CONNECT_GOCHI_EVENT_SETTING_REQUEST =
  'CONNECT_GOCHI_EVENT_SETTING_REQUEST';
export const CONNECT_GOCHI_EVENT_SETTING_SUCCESS =
  'CONNECT_GOCHI_EVENT_SETTING_SUCCESS';
export const CONNECT_GOCHI_EVENT_SETTING_FAILURE =
  'CONNECT_GOCHI_EVENT_SETTING_FAILURE';

export const UPDATE_STATUS_GOCHI_EVENT_SETTING_REQUEST =
  'UPDATE_STATUS_GOCHI_EVENT_SETTING_REQUEST';
export const UPDATE_STATUS_GOCHI_EVENT_SETTING_SUCCESS =
  'UPDATE_STATUS_GOCHI_EVENT_SETTING_SUCCESS';
export const UPDATE_STATUS_GOCHI_EVENT_SETTING_FAILURE =
  'UPDATE_STATUS_GOCHI_EVENT_SETTING_FAILURE';

export const getGochiEventSetting = params => dispatch => {
  dispatch({ type: GET_GOCHI_EVENT_SETTING_REQUEST });
  return getGochiEventSettingData(params)
    .then(response =>
      dispatch({
        type: GET_GOCHI_EVENT_SETTING_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_EVENT_SETTING_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochiEventSettingDetail = gochiEventId => dispatch => {
  dispatch({ type: GET_GOCHI_EVENT_SETTING_DETAIL_REQUEST });
  return getGochiEventSettingDetailData(gochiEventId)
    .then(response =>
      dispatch({
        type: GET_GOCHI_EVENT_SETTING_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_EVENT_SETTING_DETAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const addGochiEventSetting = params => dispatch => {
  dispatch({ type: ADD_GOCHI_EVENT_SETTING_REQUEST });
  return addGochiEventSettingData(params)
    .then(response =>
      dispatch({
        type: ADD_GOCHI_EVENT_SETTING_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GOCHI_EVENT_SETTING_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const editGochiEventSetting = (gochiEventId, params) => dispatch => {
  dispatch({ type: EDIT_GOCHI_EVENT_SETTING_REQUEST });
  return editGochiEventSettingData(gochiEventId, params)
    .then(response =>
      dispatch({
        type: EDIT_GOCHI_EVENT_SETTING_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: EDIT_GOCHI_EVENT_SETTING_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const deleteEventSetting = (gochiEventId, params) => dispatch => {
  dispatch({ type: DELETE_EVENT_SETTING_REQUEST });
  return deleteEventSettingData(gochiEventId, params)
    .then(response =>
      dispatch({
        type: DELETE_EVENT_SETTING_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_EVENT_SETTING_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochiEventSettingByMenu = (menuId, params) => dispatch => {
  dispatch({ type: GET_GOCHI_EVENT_SETTING_BY_MENU_REQUEST });
  return getGochiEventSettingDataByMenuId(menuId, params)
    .then(response =>
      dispatch({
        type: GET_GOCHI_EVENT_SETTING_BY_MENU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_EVENT_SETTING_BY_MENU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const connectGochiEventSetting = (menuId, params) => dispatch => {
  dispatch({ type: CONNECT_GOCHI_EVENT_SETTING_REQUEST });
  return connectGochiEventSettingData(menuId, params)
    .then(response =>
      dispatch({
        type: CONNECT_GOCHI_EVENT_SETTING_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: CONNECT_GOCHI_EVENT_SETTING_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const updateStatusGochiEventSetting = params => dispatch => {
  dispatch({ type: UPDATE_STATUS_GOCHI_EVENT_SETTING_REQUEST });
  return updateStatusGochiEventSettingData(params)
    .then(response =>
      dispatch({
        type: UPDATE_STATUS_GOCHI_EVENT_SETTING_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UPDATE_STATUS_GOCHI_EVENT_SETTING_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
